module.exports = __webpack_public_path__ + "static/img/round_th.6ce3b4e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sa/round_th.png
// module id = ncn4
// module chunks = 1